module.exports = __webpack_public_path__ + "static/img/unit6.5b31210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unit6.png
// module id = VMPe
// module chunks = 1